module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-16x10-desktop@4x.ce2f68b6.png";